import { Box } from "@material-ui/core";
import React from "react";

const TabPanel = (props) => {
    const { children, value, index, verticalPaddings, ...other } = props;

    return (
        <div role="tabpanel" hidden={value !== index} {...other}>
            <Box py={verticalPaddings}>{value === index && children}</Box>
        </div>
    );
};

export default TabPanel;
